import React from 'react'
import './NoteTooltip.css'

const NoteTooltip = ({subject, body, cause = ''}) => {
  return (
    <div className='noteTooltip'>
      {subject &&
      <div className='ttSubject'>
        {subject} {cause !== '' ? '. Cause: '+cause : ''}
      </div>
      }      
      <div className='ttBody'>
        {body}
      </div>
    </div>
  )
}

export default React.memo(NoteTooltip);